import React, { useState } from "react";
import { FaFish, FaStore, FaConciergeBell, FaUtensils } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const models = [
  { name: "United", category: "Multi decks", image: "images/united.png", description: "Compact multi-deck unit offering easy access and visibility for all types of sushi.", route: "/united" },
  { name: "Vista Grab & Go", category: "Semi-Verticals", image: "images/vistagrabgo.jpg", description: "Convenient grab-and-go unit, ideal for sushi on the move, with a modern look.", route: "/vista-grab-and-go" },
  { name: "Daisy", category: "Display", image: "images/daisy2.jpg", description: "Elegant sushi display unit designed to showcase your fresh sushi in style.", route: "/daisy-upper" },
  { name: "Futuro 2", category: "Multi decks", image: "images/futuro2.jpg", description: "Multi-deck design with ample space for sushi plates, perfect for busy sushi bars.", route: "/futuro-2" },
  { name: "Daisy", category: "Display", image: "images/newdaisy.jpg", description: "An elegant, user-friendly model, designed to fit in both modern and classic coffee shops.", route: "/daisy-lower" },
  { name: "Futuro 2", category: "Semi-Verticals", image: "images/FUTURO-upper.jpg", description: "Sleek and stylish semi-vertical sushi display perfect for modern restaurants.", route: "/FUTURO2-upper" },
];



const icons = [
  { name: "Fish", icon: <FaFish /> },
  { name: "Store", icon: <FaStore /> },
  { name: "Service", icon: <FaConciergeBell /> },
  { name: "Utensils", icon: <FaUtensils /> },
];

function Sushi() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();

  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/sushi1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Sushi</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          Complete and customized solutions for Sushi preparation, exhibition and self-service.
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Sushi</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}

export default Sushi;

// import React, { useState } from "react";
// import { FaFish, FaStore, FaConciergeBell, FaUtensils } from "react-icons/fa";

// const models = [
//   { name: "Daisy", category: "Display", image: "images/daisy.png", description: "Elegant sushi display unit designed to showcase your fresh sushi in style." },
//   { name: "Futuro 2", category: "Multi decks", image: "images/futuro2.jpg", description: "Multi-deck design with ample space for sushi plates, perfect for busy sushi bars." },
//   { name: "United", category: "Multi decks", image: "images/united.png", description: "Compact multi-deck unit offering easy access and visibility for all types of sushi." },
//   { name: "Vista Grab & Go", category: "Semi-Verticals", image: "images/vista.jpg", description: "Convenient grab-and-go unit, ideal for sushi on the move, with a modern look." },
//   { name: "Futuro 2", category: "Semi-Verticals", image: "images/futuro.jpg", description: "Sleek and stylish semi-vertical sushi display perfect for modern restaurants." },
// ];

// const icons = [
//   { name: "Fish", icon: <FaFish /> },
//   { name: "Store", icon: <FaStore /> },
//   { name: "Service", icon: <FaConciergeBell /> },
//   { name: "Utensils", icon: <FaUtensils /> },
// ];

// function Sushi() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const modelsPerPage = 6;

//   // Get the current models for the current page
//   const indexOfLastModel = currentPage * modelsPerPage;
//   const indexOfFirstModel = indexOfLastModel - modelsPerPage;
//   const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

//   // Handle page change
//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   // Calculate total pages
//   const totalPages = Math.ceil(models.length / modelsPerPage);

//   return (
//     <div className="w-full">
//       {/* Hero Section */}
//       <section
//         className="relative text-center w-full h-screen"
//         style={{
//           backgroundImage: "url('images/sushi1.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//           <h1 className="text-4xl font-bold mb-4 md:text-8xl">Sushi</h1>
//           <p className="text-lg max-w-2xl md:text-3xl">
//             Discover our innovative and stylish models for displaying sushi, designed for every kind of sushi business.
//           </p>
//         </div>
//       </section>

//       {/* Models Display */}
//       <section className="px-6 py-12 md:px-32">
//         <h2 className="text-4xl md:text-7xl font-bold text-center mb-10">Our Sushi Models</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
//           {currentModels.map((model, index) => (
//             <div key={index} className="text-center">
//               <div
//                 className="relative w-full h-80 mb-4"
//                 style={{
//                   backgroundImage: `url(${model.image})`,
//                   backgroundSize: "contain", // Ensures no cuts, full image shown
//                   backgroundPosition: "center",
//                   backgroundRepeat: "no-repeat",
//                   height: "300px",
//                 }}
//               ></div>
//               <h3 className="text-2xl font-semibold mb-2">{model.name}</h3>
//               <p className="text-sm opacity-80 ">{model.category}</p>
//               <p className="text-sm max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

//               {/* Small icons under each model */}
//               <div className="flex justify-center gap-4">
//                 {icons.map((icon, index) => (
//                   <div key={index} className="text-2xl">
//                     {icon.icon}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Pagination */}
//         <div className="flex justify-center mt-10">
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             className="px-4 py-2 bg-gray-800 text-white rounded-l"
//           >
//             Previous
//           </button>
//           <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 bg-gray-800 text-white rounded-r"
//           >
//             Next
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Sushi;
